import React, { useState } from "react";
import "./progressive_circle.css";
import Menu from '../Menu/menu';

const ProgressCircle = ({ maxSalary, availableSalary, withdrawAmount, setWithdrawAmount }) => {
  const radius = 100; // Radio del círculo
  const circumference = 2 * Math.PI * radius; // Circunferencia del círculo
  const progress = availableSalary > 0 ? (withdrawAmount / availableSalary) * 100 : 0; // Progreso en porcentaje sino 0


  const strokeDashoffset = circumference - (progress / 100) * circumference;
  
  // Calcular la posición del "botón" al final del progreso
  const angle = (progress / 100) * 2 * Math.PI - Math.PI / 2; // Convertir el progreso a ángulo
  const buttonX = 150 + radius * Math.cos(angle); // Coordenada X del "botón"
  const buttonY = 150 + radius * Math.sin(angle); // Coordenada Y del "botón"

  const [isEditing, setIsEditing] = useState(false); // Estado para modo edición
  const [editValue, setEditValue] = useState(withdrawAmount); // Estado temporal para edición

  const handleSliderChange = (e) => {
    const value = Math.round(Number(e.target.value) / 10) * 10; // Redondear al múltiplo de 10 más cercano
    setWithdrawAmount(value);
    setEditValue(value); // Sincronizar el valor editable
  };

  const handleInputChange = (e) => {
    const value = Number(e.target.value);

    // Validar que sea divisible entre 10 y no exceda el salario disponible
    if (value % 10 === 0 && value <= availableSalary) {
      setWithdrawAmount(value);
    }
  };

  const handleBlur = () => {
    if (withdrawAmount % 10 !== 0 || withdrawAmount > availableSalary) {
      setWithdrawAmount(Math.floor(withdrawAmount / 10) * 10);
    }
    setIsEditing(false);
  };

  
  return (
    <div className="progress-container">
      <div className="circle-container">
        <svg height="300" width="300" className="progress-circle">
          <defs>
            <linearGradient id="progressGradient" gradientTransform="rotate(90)">
              <stop offset="0%" stopColor="#A4D6A0" />
              <stop offset="100%" stopColor="#70A771" />
            </linearGradient>
          </defs>
          <circle
            className="circle-bg"
            stroke="#e6e6e6"
            strokeWidth="20"
            fill="transparent"
            r={radius}
            cx="150"
            cy="150"
          />
          <circle
            className="circle"
            stroke="url(#progressGradient)"
            strokeWidth="20"
            strokeDasharray={circumference}
            strokeDashoffset={isNaN(strokeDashoffset) ? 0 : strokeDashoffset}
            fill="transparent"
            r={radius}
            cx="150"
            cy="150"
          />
          {/* Círculo del "botón" */}
          <circle
            className="progress-button"
            cx="150"
            cy="50" // Inicializa el botón en la parte superior
            r="10" // Tamaño del "botón"
            fill="#fff"
            stroke="#ccc"
            strokeWidth="2"
            style={{
              transform: `rotate(${90 + (progress / 100) * 360}deg)`,
              transformOrigin: '150px 150px',
            }}
          />
        </svg>
        <div className="text-container">
          <p className="withdraw-text">Retirar</p>
          {isEditing ? (
            <input
              type="number"
              value={withdrawAmount}
              min="0"
              max={availableSalary}
              step="10"
              onChange={handleInputChange}
              onBlur={handleBlur}
              autoFocus
              className="editable-amount"
            />
          ) : (
            <p
              className="withdraw-amount editable"
              onClick={() => setIsEditing(true)}
            >
              {withdrawAmount} UYU
            </p>
          )}
        </div>
      </div>
      <input
        type="range"
        min="0"
        max={availableSalary || 1}
        step="10"
        value={withdrawAmount}
        onChange={handleSliderChange}
      />
    </div>
  );
};

export default ProgressCircle;